// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wMbU","list":"styles_list__1qbkM","disableSelection":"styles_disableSelection__1h17t"};